var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-500"},[_vm._v("500")]),_c('div',{staticClass:"not-found-title"},[_vm._v(_vm._s(_vm._T('Server error')))]),_c('a',{staticClass:"not-found-link",attrs:{"href":"/"}},[_vm._v(_vm._s(_vm._T('Go to home page')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }